'use client';

import { useState } from 'react';
import { X } from 'lucide-react';

import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { cn } from '@/lib/utils';

type ArticleFootnoteProps = {
  text: string;
  description?: string | null;
};

export function ArticleFootnote({ text, description }: ArticleFootnoteProps) {
  const [open, setOpen] = useState(false);
  const trimmedText = text.trim();
  if (!trimmedText) return null;

  const trimmedDescription = description?.trim();

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          className={cn(
            'cursor-pointer rounded-[4px] border border-[#c8c8c8] bg-transparent px-[3px] py-0 font-inherit text-inherit leading-none',
            'hover:bg-black/5 dark:border-[#6b6b6b] dark:hover:bg-white/10',
          )}
          style={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}
          aria-expanded={open}
          aria-haspopup="dialog"
        >
          {trimmedText}
        </button>
      </PopoverTrigger>
      {trimmedDescription ? (
        <PopoverContent
          side="bottom"
          align="center"
          sideOffset={6}
          className="w-[90vw] max-w-[390px] rounded-lg border border-border-quote bg-white p-4 text-foreground shadow-[0_4px_14px_rgba(0,0,0,0.15)] dark:border-[#373737] dark:bg-[#25282E] dark:text-white"
        >
          <div className="flex items-start justify-between gap-3">
            <div className="text-base font-semibold leading-[140%] break-words">{trimmedText}</div>
            <button
              type="button"
              onClick={() => setOpen(false)}
              className="mt-0.5 shrink-0 rounded p-0.5 text-muted-foreground hover:text-foreground"
              aria-label="Закрыть сноску"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
          <div className="mt-2 text-sm leading-[140%] break-words">{trimmedDescription}</div>
        </PopoverContent>
      ) : null}
    </Popover>
  );
}
